import axiosInstance from '../configs/axios/interceptors';
import { handleDateConvertForApis } from '../utils/functions';

const DistinteDocumentServices = {

    getDistinteDocuments: async (filters) => {
        const response = await axiosInstance.get('Document_Distinte/GetDocument_DistinteList', { params: filters });
        return response.data;
    },

    getDocumentDetails: async (documentId, userId) => {
        const params = { documentId, userId };
        const response = await axiosInstance.get('Document_Distinte/GetDocument_DistinteDetails', { params: params });
        return response.data;
    },

    addDocument: async (payload) => {
        const response = await axiosInstance.post('Document_Distinte/AddDocument_Distinte', payload, { params: payload });
        return response.data;
    },

    updateDocument: async (payload) => {
        const response = await axiosInstance.put('Document_Distinte/UpdateDocument_Distinte', payload);
        return response.data;
    },

    deleteDocument: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.delete('Document_Distinte/RemoveDocument_Distinte', { params: params });
        return response.data;
    },

    getSelectedDocumentsList: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Document_Distinte/GetDocuments_DistinteListExport', cleanBody);
        return response.data;
    },

    getDocumentListAttachments: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Attachment_Distinte/GetDocument_DistinteListAttachments', cleanBody);
        return response.data;
    },

    getDocumentNotes: async (documentId) => {
        const params = { documentID: documentId };

        const response = await axiosInstance.get('Document_Distinte/GetDocumentNotes_Distinte', { params: params });
        return response.data;
    },

    addDocumentNote: async (payload) => {
        const params = { "documentID": payload.documentID, "note": payload.note, "userID": payload.userID };
        const response = await axiosInstance.post('Document_Distinte/AddDocumentNote_Distinte', payload, { params: params });
        return response.data;
    },

    getDocumentAttachments: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.get('Attachment_Distinte/GetAttachments_Distinte', { params: params });
        return response.data;
    },

    addDocumentAttachment: async (payload) => {
        const response = await axiosInstance.post('Attachment_Distinte/UploadFile_Distinte', payload);
        return response.data;
    },

    removeDocumentAtachment: async (attachmentId, userId) => {
        const params = { attachmentID: attachmentId, userID: userId };

        const response = await axiosInstance.delete('Attachment_Distinte/DeleteAttachment_Distinte', { params: params });
        return response.data;
    },

    readDocumentPDF: async (documentId) => {
        const params = { documentID: documentId };
        const response = await axiosInstance.get('Attachment_Distinte/ReadPDF_Distinte', { params: params });
        return response.data;
    },

    removeDocumentNote: async (noteId) => {
        const params = { documentNoteID: noteId };
        const response = await axiosInstance.delete('Document_Distinte/RemoveDocumentNote_Distinte', { params: params });
        return response.data;
    },
};

export default DistinteDocumentServices;